import { CustomDataInputField } from './CustomDataInputField';

export default CustomDataInputField;
